import React, { FC } from 'react'
import './index.scss'

export const Snackbar: FC<any> = (props: any) =>
    <p style={ { display: "flex", alignItems: "center" } }>
        <span style={ { marginRight: "7px" } } className="material-icons animated jello">{ props.icon }</span>
        { props.children }
    </p>
